/**
 * Copy do painel Status integrações para a nota NSTech (TMS-7222, A3 e A6).
 *
 * Literais: quem audita a copy lê strings, quem audita a regra lê funções — a
 * interpolação dos `{placeholders}` mora em `src/utils/nstechNotaEstado.js`.
 * Mesma forma de `ocorrenciaIntegracaoCopy.js`.
 *
 * O MOTIVO e a ORIENTAÇÃO não estão aqui: vêm prontos do backend (`motivo`,
 * `orientacao` da linha NSTech), porque a tabela motivo → orientação é do
 * ADR-0003 (adendo de 2026-10-15) e mora em `OrientacaoRecusaNstech`.
 */

/** Nota recusada pela NSTech (há linha ou log da recusa). */
export const TITULO_NOTA_RECUSADA = "A NSTech recusou a nota {numDoc}";

/** Nota que nem chegou à NSTech (sem linha de integração). */
export const TITULO_NOTA_NAO_ENVIADA = "Nota não enviada à NSTech";

export const ACAO_REENVIAR = "Reenviar esta nota";
export const ACAO_REENVIANDO = "Reenviando…";
/** Job de reenvio em voo (back: `reenvio_em_andamento`); o botão fica desabilitado. */
export const ACAO_REENVIO_EM_ANDAMENTO = "Reenvio em andamento…";

export const DETALHES_ROTULO = "Ver detalhes";

export const DETALHE_CARGA = "Carga";
export const DETALHE_NOTA = "Nota";
export const DETALHE_ULTIMA_TENTATIVA = "Última tentativa";
export const DETALHE_MENSAGEM = "Mensagem da NSTech";

/** Contador de espera (A6). */
export const ESPERA_EM_PROCESSAMENTO = "Em processamento na NSTech há {tempo}";
export const ESPERA_MENOS_DE_UM_MINUTO = "menos de 1 min";

export const REENVIO_SUCESSO_TITULO = "Reenvio solicitado";
export const REENVIO_SUCESSO_MENSAGEM =
  "A nota foi enviada para reenvio. Acompanhe o resultado neste painel.";
export const REENVIO_FALHA_TITULO = "Não foi possível reenviar a nota";
export const REENVIO_FALHA_MENSAGEM =
  "O reenvio da nota não foi aceito. Tente novamente ou acione o suporte informando o número da carga.";
